export const version = "random/5.5.0";
